// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Elemnet from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/newicon/iconfont.css'
import './assets/newicon/lib/mw.css'
import resource from 'vue-resource';
import common from '../commonFunction/common.js';
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import pdf from 'vue-pdf'
import 'lib-flexible'  //淘宝弹性布局
Vue.use(pdf)
Vue.use(codemirror)
Vue.prototype.common = common
Vue.use(Elemnet)
Vue.use(resource)
window.socket_dot=false;
Vue.prototype.socket_vip=true;
//Vue.prototype.apiUrl='http://39.104.14.210/dataGalaxy/' //39服务器
//Vue.prototype.apiUrl='http://datagalaxy.yeesight.com/v2/admin/'
// Vue.prototype.apiUrl='http://47.93.51.30/ByteVOfficialBMS/admin/'
// Vue.prototype.apiUrl='http://120.92.84.211:8081/'
Vue.prototype.apiUrl='http://47.93.51.30:80/ByteVOfficialBMS/admin/'
Vue.config.productionTip = false
/* eslint-disable no-new */

/****************************************************/
//百度友盟单页面和websocket
let socketflag = true;
router.beforeEach((to, from, next) => {
		if(sessionStorage.getItem('usercode') && socketflag){
			socketflag = false;
//			window.socket = io('http://datagalaxy.yeesight.com/');
			window.socket = io('http://datagalaxy.yeesight.com/');
		    // uid可以是自己网站的用户id，以便针对uid推送以及统计在线人数
//		    var uid = 123;
		    // socket连接后以uid登录
		    window.socket.on('connect', function(){
		      window.socket.emit('login', sessionStorage.getItem('usercode'));
		    });
		    // 后端推送来消息时
//		    window.socket.on('new_msg', function(msg){
//		        console.log("收到消息："+msg);
//		    }); 
//		    // 后端推送来在线数据时
		    window.socket.on('update_online_count', function(online_stat){
		        console.log(online_stat);
		    });



			//方案二
//			if(sessionStorage.getItem('usercode') && !sessionStorage.getItem('socket_dot')){
//				$.ajax({
//					type:'post',
//					data:{usercode:sessionStorage.getItem('usercode')},
//					url:'http://39.104.14.210/dataGalaxy/index.php?m=Api&c=Content&a=openDemo',
//					success: function(data){
//						if(data.status==1){
////							var tempwindow=window.open(data.data,_blank); // 先打开页面
//							sessionStorage.setItem('socket_dot')
//						}else{
////							console.log(data);
//						}
//					},
//					error:function(){
////						console.log(data);
//					}
//				})
//			}
				
		}
		
		
/*******************************************************************************************/		
	//百度友盟单页面
	    if (to.path) {
	        _hmt.push(['_trackPageview', '/#' + to.fullPath]);
	    }
	    next();
});


new Vue({
  el: '#datagalaxy',
  router,
  resource,
  pdf,
  components: { App },
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js